import React, { memo, useEffect, useMemo, useState } from 'react';
import { SymbolItem } from './SymbolItem';
import { setMenuSymbol, setSymbolActive } from '../../../redux/reducer/instruments';
import DropDownPanel from '../../dropdown';
import DropDownProvider from '../../dropdown/provider';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { setDropdown } from '../../../redux/reducer/dropdown';
import useGetLastTick from '../../../data/useLastTick';
import useAuth from '../../../hooks/useAuth';
import { SymbolInfoSchema } from '../../../types/symbol';

const CustomScrollTopMenu = memo(() => {
  const { activeAccount, listArray } = useAuth();
  const { menu } = useAppSelector(({ symbol }) => symbol);
  const { open } = useAppSelector(({ dropdown }) => dropdown);
  const [sizeEle, setSizeEle] = useState(undefined);
  const { getLastTick } = useGetLastTick();

  const currentMenu = useMemo(() => {
    const symbolData = menu[activeAccount].menu.map((b) => {
      const matchSymbol = listArray.find((item) => item.symbol === b.symbol);
      return {
        ...b,
        ...matchSymbol
      };
    }, []);

    return {
      ...menu[activeAccount],
      menu: symbolData
    };
  }, [menu, activeAccount]);

  const dispatch = useAppDispatch();

  const handleClick = async (type, value, data) => {
    // const dataProps = SymbolInfoSchema.parse(data);

    if (type === 'select') {
      await getLastTick(data.symbol);
      dispatch(setSymbolActive(data.symbol));
    }
    if (type === 'close') {
      const lastActive = currentMenu.menu.slice(0, value);
      if (value === currentMenu.menu.length - 1) {
        await getLastTick(lastActive[value - 1].symbol);
        dispatch(
          setMenuSymbol({
            type: 'del',
            symbol: data.symbol,
            active: lastActive[value - 1].symbol
          })
        );
        dispatch(setSymbolActive(lastActive[value - 1].symbol));
      } else {
        await getLastTick(currentMenu.active);
        dispatch(
          setMenuSymbol({
            type: 'del',
            symbol: data.symbol,
            active: currentMenu.active
          })
        );
        dispatch(setSymbolActive(currentMenu.active));
      }
    }
  };

  const toggle = (el) => {
    dispatch(setDropdown(el));
  };

  useEffect(() => {
    if (!sizeEle) {
      setSizeEle(
        setTimeout(() => {
          var max_beaver_width = document.querySelector('#customScrollTopMenu');
          setSizeEle(max_beaver_width?.offsetWidth);
        }, 1000)
      );
    } else {
      const body = document.getElementsByTagName('body');
      if (body.length > 0) {
        // eslint-disable-next-line no-undef
        const resizeObserver = new ResizeObserver((e) => {
          if (e.length > 0) {
            let max_beaver_width = document.querySelector('#customScrollTopMenu');
            setSizeEle(max_beaver_width?.offsetWidth);
          }
        });
        resizeObserver.observe(body[0]);
        return () => {
          resizeObserver.disconnect();
        };
      }
    }
  }, [sizeEle]);

  return (
    currentMenu && (
      <div
        id="customScrollTopMenu"
        className="flex items-center pl-4 overflow-x-auto h-[65px] w-full">
        <div className="flex items-center gap-2">
          {currentMenu.menu.map((e, index) => (
            <div
              key={index}
              style={{
                transition: 'all 0.3s ease-in'
              }}
              className={`relative ${index === 0 && 'ml-0'} ${
                currentMenu.menu.length * 120 + 250 > sizeEle ? '-ml-[50px]' : '-ml-0'
              }`}>
              <SymbolItem
                lastIndex={currentMenu?.menu?.length === 1}
                symbolInfo={e}
                handleClick={handleClick}
                keyIndex={index}
                active={e.symbol === currentMenu?.active}
                length={currentMenu.menu.length}
                maxW={currentMenu.menu.length * 120 + 250 > sizeEle}
              />
            </div>
          ))}
        </div>
        <div className="relative">
          <button
            className="btn-add flex justisfy-center items-center"
            onClick={() => {
              toggle(!open);
            }}>
            <svg
              className="m-auto"
              width="15px"
              height="15px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                {' '}
                <g id="Edit / Add_Plus">
                  {' '}
                  <path
                    id="Vector"
                    d="M6 12H12M12 12H18M12 12V18M12 12V6"
                    stroke="#9f9f9f"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"></path>{' '}
                </g>{' '}
              </g>
            </svg>
          </button>
          {open && (
            <div
              className="fixed w-full h-full left-0 top-0 bg-[#0e0e0e00] z-[4]"
              onClick={() => {
                toggle(!open);
              }}></div>
          )}
          <DropDownProvider open={open}>
            {open && <DropDownPanel toggle={toggle} />}
          </DropDownProvider>
        </div>
        {/* <div className="bg-[red] w-full h-full sidebar-draggable"></div> */}
      </div>
    )
  );
});

CustomScrollTopMenu.displayName = 'CustomScrollTopMenu';
export default CustomScrollTopMenu;
